import { useSelector } from "react-redux";

import { Typography } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

export const Toggle = ({ value, options, onChanged, width, styles }) => {
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;

  return (
    <ToggleButtonGroup
      value={value}
      onChange={(e, v) => {
        if (v) {
          onChanged(v);
        }
      }}
      exclusive
    >
      {options.map((option, index) => (
        <ToggleButton value={option} key={index}>
          <Typography noWrap style={{ width, ...styles }}>
            {option === `${currencySymbol}/Sqft`
              ? `${currencySymbol}/${user?.unit_system}`
              : option}
          </Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
